import io from "socket.io-client";
import { config } from "../../../config/configUi.js";
import { ClientsController } from "./ClientsController";

import _ from "lodash";

const WS_USER_DISABLED_KEY = "wsUserDisabled";

class ClientsSocketController {
  store: any;
  clientsController: ClientsController;
  socket: any;
  connectedDepot: any = null;

  constructor(store, clientsController) {
    this.store = store;
    this.clientsController = clientsController;
    this.store.clientsSocket = this;
  }

  get isUserDisabled() {
    return this.store.statusBar.wsUserDisabled;
  }

  toggle = () => {
    const nextDisabled = !this.isUserDisabled;
    localStorage.setItem(WS_USER_DISABLED_KEY, nextDisabled ? "true" : "false");
    this.store.statusBar.wsUserDisabled = nextDisabled;

    if (nextDisabled) {
      this.disconnectSocket();
      this.socket = null;
      this.store.statusBar.wsConnected = false;
      this.store.displayNotification("Socket disabled", "info", true);
    } else {
      this.openintApiSocket();
      this.store.displayNotification("Socket enabled", "info", true);
    }
  };

  openintApiSocket = () => {
    console.log("Clients Socket Controller - Opening.");

    // Close the socket if it was already open.
    if (this.socket) {
      this.store.enableConsoleLogs && console.log("Clients Socket Controller - Closing old connection.");
      this.socket.disconnect();
      this.socket.close();
      this.socket.removeAllListeners();
    }

    // Reset values.
    this.socket = null;
    this.connectedDepot = null;

    // Fetch URL + Optional Path Suffix and Virtual Path.
    const wsUrl = _.get(config, "websocketConfig.clients.url", "");
    const wsPathSuffix = _.get(config, "websocketConfig.clients.suffixPath", "");
    const wsVPath = _.get(config, "websocketConfig.clients.virtualPath", "");

    // Open socket.
    this.socket = io(wsUrl + "/" + wsVPath + "/dispatcher", {
      path: wsPathSuffix + "/" + wsVPath + "/socket.io",
      reconnectionDelay: _.get(config, "websocketConfig.settings.reconnectionDelay", 1000),
      reconnectionDelayMax: _.get(config, "websocketConfig.settings.reconnectionDelayMax", 5000),
      randomizationFactor: _.get(config, "websocketConfig.settings.randomizationFactor", 0.5),
    });

    // Bind the sockets.
    this.socket.on("message", this.handleWSReceiveMessage);
    this.socket.on("connect", this.notifyIntConnected);
    this.socket.on("disconnect", this.notifyIntDisconnected);
    this.socket.on("error", this.notifySocketError);
    this.socket.on("connect_error", (error) => {
      console.error("Connection error:", error);
    });
  };

  connectSocket = () => {
    if (this.isUserDisabled) {
      this.store.enableConsoleLogs && console.log("Clients Socket Controller - User disabled, skipping connect.");
      return;
    }
    if (!this.socket || !this.socket.connected) {
      this.openintApiSocket();
    }
  };

  disconnectSocket = () => {
    if (this.socket) {
      this.store.enableConsoleLogs && console.log("Clients Socket Controller - Closing Old Connection.");
      this.socket.disconnect();
      this.socket.close();
      this.socket.removeAllListeners();
    }
  };

  notifyIntConnected = () => {
    this.store.statusBar.wsConnected = true;
    console.log("Clients Socket Controller - Connected.");
  };

  notifyIntDisconnected = () => {
    this.store.statusBar.wsConnected = false;
    this.store.statusBar.connectedDepot = null;
    this.connectedDepot = null;
    this.store.enableConsoleLogs && console.log("Clients Socket Controller - Disconnected");
  };

  subscribeToDepot = (depotId) => {
    if (depotId != null && this.connectedDepot != depotId) {
      this.connectedDepot = depotId;
      this.socket.emit("subscribe", depotId);
    }
  };

  unsubscribeFromDepot = () => {
    if (this.connectedDepot) {
      this.store.enableConsoleLogs && console.log("Clients Socket Controller - Unsubscribed from Depot : ", this.connectedDepot);

      // Unsubscribe.
      this.socket.emit("unsubscribe", this.connectedDepot);

      // Reset values.
      this.connectedDepot = null;
      this.store.statusBar.connectedDepot = null;
    }
  };

  checkSocketConnection = () => {
    this.store.enableConsoleLogs && console.log("Clients Socket Controller - Connected Depot : ", this.connectedDepot);
    this.store.enableConsoleLogs && console.log("Clients Socket Controller - Status : ", this.socket);
  };

  notifySocketError = (error) => {
    console.log("Clients Socket Controller Socket Error :", error);
  };

  handleWSReceiveMessage = (message) => {
    console.log("Clients Socket Controller - : ", message);

    if (message.type === "CLIENT") {
      const currentUser = message.user === this.store.user._id;

      if (currentUser) {
        this.store.setPreLoaderProps({
          loading: message.data.finished ? false : true,
          loadingText: message.data.message,
        });
      }

      if (message.data.finished === true) {
        this.clientsController.finishClientCreateResetProcess(message.action === "RESET", message.data, currentUser);
      }
    }
    // Check if the current client should process the request.
    // if (this.clientsController.containsUIRequestID(message.data.uiRequestID)) {
    //   this.store.enableConsoleLogs && console.log('DELIVERY-DATES (GET) : ', message)
    //   this.clientsController.getAvailableSlots(_.get(message, 'data.dispatchJobId'), _.get(message, 'data.id'))
    // }
  };
}
export { ClientsSocketController };
